import { InjectionToken } from '@angular/core';

/**
 * Interface for the processing API configuration.
 */
export interface ProcessingServiceConfig {
  url: string;
}

/**
 * This injection token can be used to inject the processing API configuration.
 */
export const PROCESSING_CONFIG = new InjectionToken<ProcessingServiceConfig>('ProcessingServiceConfig');
